import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Field } from 'redux-form';

import './styles.scss';

const Select = (props) => {
  const {
    append,
    prepend,
    size,
    options,
    className,
    classNameControl,
    classNameWrapper,
    input,
    meta: { error, touched },
    fieldLabel,
    supText,
    ...otherProps
  } = props;

  return (
    <div className={cn('select-wrapper', classNameWrapper)}>
      {fieldLabel && (
        <label htmlFor={input.name}>
          {fieldLabel}
          {supText && (
            <sup>{` ${supText}`}</sup>
          )}
        </label>
      )}
      <div className={cn('input-group', className)}>
        {prepend && (
          <div className="input-group-prepend">
            <span className="input-group-text">{prepend}</span>
          </div>
        )}
        <select
          className={
            cn('custom-select', classNameControl, { 'is-invalid': touched && error }, size && `form-control-${size}`)
          }
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...otherProps}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...input}
        >
          {options.map(({ value, label, disabled = false }) => (
            <option
              key={value}
              value={value}
              disabled={disabled}
            >
              {label || value}
            </option>
          ))}
        </select>
        {append && (
          <div className="input-group-append">
            <span className="input-group-text">{append}</span>
          </div>
        )}
        {touched && error && (
          <div className="invalid-feedback show-input-error">{error}</div>
        )}
      </div>
    </div>
  );
};

Select.propTypes = {
  classNameControl: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
  })).isRequired,
  append: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  prepend: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  input: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.number,
  ])).isRequired,
  meta: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.func,
  ])).isRequired,
  fieldLabel: PropTypes.string,
  supText: PropTypes.string,
  classNameWrapper: PropTypes.string,
};

Select.defaultProps = {
  size: null,
  fieldLabel: null,
  supText: null,
  append: null,
  prepend: null,
  classNameControl: null,
  className: null,
  classNameWrapper: null,
};
// eslint-disable-next-line react/jsx-props-no-spreading
const ReduxSelect = (props) => <Field {...props} component={Select} />;

export default ReduxSelect;
